module.exports = __webpack_public_path__ + "static/media/g7.b35b7bd1.jpg";